<template>
  <div id="products">
    <div class="columns">
      <div class="column">
        <div class="notification" v-show="loading">Laden...</div>

        <div class="notification is-danger" v-if="errors">{{ errors }}</div>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div class="field">
          <div class="control">
            <input type="text" class="input" v-model="query" placeholder="zoeken">
          </div>
        </div>
      </div>

      <div class="column is-one-quarter is-offset-one-quarter">
        <router-link
          v-if="myProducts.length > 0 || isAdmin"
          class="button"
          :to="{ name: 'product-edit', params: { id: false } }"
        >Nieuw product</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="column is-half">
        <div v-if="myProducts.length === 0 && isSupplier" class="notification">
          Hier kun je nieuwe producten toevoegen aan de Droombronnenbank. Er staan nog geen producten in de Droombronnenbank van {{ this.accountData.supplier.name }}. Klik <router-link :to="{ name: 'product-edit', params: { id: false } }">hier</router-link> om een product toe te voegen.
        </div>

        <div v-else class="box" v-for="product in myProducts" :key="product.id">
          <router-link :to="{ name: 'product-edit', params: { id: product.id } }">{{ product.name }}</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '@/main'

  export default {
    data() {
      return {
        loading: false,
        products: [],
        suppliers: null,
        errors: null,
        query: ''
      };
    },
    computed: {
      isAdmin () {
        return this.$store.getters.isAdmin
      },
      isSupplier () {
        return this.$store.getters.isSupplier
      },
      accountData () {
        return this.$store.getters.accountData
      },
      params () {
        return this.$store.getters.params
      },
      myProducts () {
        if (this.isAdmin)
          return this.products.filter(product => product.name.toLowerCase().includes(this.query.toLowerCase()))

        return this.products.filter((product) => {
          return product.supplier_id === this.accountData.supplier.id &&
            product.name.toLowerCase().includes(this.query.toLowerCase())
        })
      }
    },
    created () {
      this.fetchData()
    },
    // TODO: The backend should only return products that the user has access to based on it's access token.
    methods: {
      fetchData () {
        this.loading = true;
        axios
          .get('/products')
          .then(response => {
            this.loading = false
            this.products = response.data
          }).catch(error => {
            this.loading = false
            this.error = error.response.data.message || error.message
          });
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/products/Products.vue